import axios from 'axios'

const LaterPostingService = {
  async get (params = {}) {
    return axios.get('prd/inter-warehouse-transfer/request-later-postings', { params })
  },

  async show (id) {
    return axios.get(`prd/inter-warehouse-transfer/request-later-postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/inter-warehouse-transfer/request-later-postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/inter-warehouse-transfer/request-later-postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/inter-warehouse-transfer/request-later-postings/${data.id}`, { data })
  }
}

export default LaterPostingService
